import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";
import { Button } from "~/components/ui/button";
import { Trash2, Loader2 } from "lucide-react";
import { useParams } from "react-router";
import { useState } from "react";
import { apiClient } from "~/lib/api-client";
import { useNavigate } from "~/lib/team-router";

export default function DeleteChatConfirmationModal() {
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { chatId } = useParams();
  const navigate = useNavigate();

  async function handleDelete() {
    if (!chatId) return;

    setIsDeleting(true);
    try {
      await apiClient.delete(`/chats/${chatId}`);

      const event = new CustomEvent("conversationUpdated");
      window.dispatchEvent(event);

      setOpen(false);
      navigate("/chats/home");
    } catch (error) {
      console.error("Failed to delete conversation:", error);
    } finally {
      setIsDeleting(false);
    }
  }

  if (!chatId) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" className="text-red-500">
          <Trash2 className="h-4 w-4" />
          <span>Delete Chat</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Conversation</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Are you sure you want to delete the conversation?
        </DialogDescription>
        <DialogFooter className="flex gap-2 md:gap-1">
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="destructive"
            disabled={isDeleting}
            autoFocus
            className="w-full sm:w-auto flex items-center gap-2"
          >
            {isDeleting ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>Deleting...</span>
              </>
            ) : (
              <>
                <Trash2 className="h-4 w-4" />
                <span>Delete</span>
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
